import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Dialog from '@material-ui/core/Dialog';
import ListItemText from '@material-ui/core/ListItemText';
import ListItem from '@material-ui/core/ListItem';
import List from '@material-ui/core/List';
import Divider from '@material-ui/core/Divider';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import IconButton from '@material-ui/core/IconButton';
import Typography from '@material-ui/core/Typography';
import CloseIcon from '@material-ui/icons/Close';
import Slide from '@material-ui/core/Slide';
import { Dropdown, Grid, Input, Button, TextArea, Form } from 'semantic-ui-react';
import Loading from '../../loadings';
import $ from "jquery";
import Server from '../../../functions/server';
import Items from './item';
import Samplerequest from './samplerequest';
import ReadCookie from '../../../functions/readcookies';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';

const styles = {
  appBar: {
    position: 'relative',
  },
  flex: {
    flex: 1,
  },
};

function Transition(props) {
  return <Slide direction="up" {...props} />;
}

class FullScreenDialog extends React.Component {

  state = {
    items: [],
    load: false,
    message: '',
    tobranch: 0,
    selectedPurchaser: 0,
    purchaseType: 'Normal'
  };

  componentDidMount() {
    this.getPurchaser();
    this.checkCookie();
    this.getPartCode();
  }

  componentDidUpdate(props) {
    if (props.branch != this.props.branch) {
      this.getPurchaser();
      this.checkCookie();
      this.getPartCode();
    }
  }

  getPartCode() {
    let context = this;
    context.setState({
      load: true,
      message: 'Getting Partno!!!'
    });
    let data = (ReadCookie("branch"));
    let branch_id;
    for (var i = 0; i < data.length; i++) {
      branch_id = data[i].branch_id;
    }
    let cook = (ReadCookie("vaigai"));
    let userId = cook.id;
    $.ajax({
      type: 'POST',
      data: { 'branch': branch_id, 'customer': userId },
      url: Server() + 'purchasedetail/getpartcode.php',
      success: function(data)
      {
        let part_id;
        context.setState({ load: false })
        try {
          data = JSON.parse(data);
          context.setPartcode(data);
        } catch (e) {
        }
      },
      error: function(err)
      {
        context.setState({
          load: false,
        });
        alert('Try again!!!!')
      }
    });
  }

  setPartcode(data, part_id){
    let context = this;
    var x = [];
    data.map((y) => {
      x.push({key: y.partno+'->'+y.spare_name+'->'+y.part_id+'->'+y.brand_id, text: y.partno+'->'+y.spare_name+'->'+y.part_id+'->'+y.brand_id, value: y.part_id});
    });
    try {
      context.setState({
        partcodeOption: x,
        parts: data
      });
    } catch (e) {

    }
  }

  checkCookie() {
    let cook = (ReadCookie("vaigai"));
    this.setState({
      userId: cook.id,
    })
  }

  getPurchaser() {
    let context = this;
    let cook = (ReadCookie("vaigai"));
    let userId = cook.id;
    this.setState({
      load: true,
      message: 'Getting Purchaser Details!!!!',
    });
    $.ajax({
      type: 'POST',
      data: { 'userId': userId, 'where': 'Purchase-Detail' },
      url: Server() + 'purchaser/getpurchaser2.php',
      success: function(data)
      {
        let purchaseState;
        context.setState({
          load: false,
        });
        try {
          data = JSON.parse(data);
          context.setPurchaser(data);
        } catch (e) {
          console.log(e);
        }
      },
      error: function(err)
      {
        context.setState({
          load: false,
        });
        alert('Try again!!!!')
      }
    });
  }

  setPurchaser(data) {
    let context = this;
    var x = [];
    data.map((y) => {
      let name = y.id + ' -> ' + y.name+ '->' + y.state;
      x.push({key: name, text: name, value: y.address_id});
    });
    try {
      context.setState({
        purchaserOption: x,
        purchaserData: data
      });
    } catch (e) {
    }
  }

  purchaser = (f, { value }) => {
    let items = this.state.items;
    let data = this.state.purchaserData;
    let id = 0;
    let state;
    let gstn;
    data.map((z) => {
      if (z.address_id == value) {
        state = z.state;
        gstn = z.gstn;
        id = z.id;
      }
    })
    for (var i = 0; i < items.length; i++) {
      if (items[i].id == i) {
        items[i].purchaser = id;
        items[i].purchaser_address_id = value;
      }
    }
    this.setState({
      items: items,
      selectedPurchaseraddress: value,
      selectedPurchaser: id,
      state: state,
      gstn: gstn
    })
  }

  tobranchs = (f, { value }) => {
    let items = this.state.items;
    for (var i = 0; i < items.length; i++) {
      if (items[i].id == i) {
        items[i].tobranch = value;
      }
    }
    this.setState({ tobranch: value, items: items })
  }

  handleChange = name => event => {
    let items = this.state.items;
    for (var i = 0; i < items.length; i++) {
      if (items[i].id == i) {
        items[i].date = event.target.value;
      }
    }
    this.setState({
      date: event.target.value,
      items: items
    });
  };

  submit() {
    let context = this;
    let cook = (ReadCookie("vaigai"));
    let userId = cook.id;
    let items = this.state.items;
    let remarks = this.state.remarks;
    let purchaseType = this.state.purchaseType;
    for (var i = 0; i < items.length; i++) {
      if (items[i].partno == '' || items[i].partno == null || items[i].partno == undefined) {
        alert('Enter all partid');
        return;
      }
      if (items[i].brand == '' || items[i].brand == null || items[i].brand == undefined) {
        alert('Enter all brand');
        return;
      }
      if (items[i].stock == '' || items[i].stock == null || items[i].stock == undefined) {
        alert('Enter all stock');
        return;
      }
      if (items[i].date == '' || items[i].date == null || items[i].date == undefined) {
        alert('Enter date');
        return;
      }
      if (items[i].branch == '' || items[i].branch == null || items[i].branch == undefined) {
        alert('Enter branch');
        return;
      }
    }
    if (this.props.requestTo == 'Purchaser') {
      if (purchaseType == '' || purchaseType == null || purchaseType == undefined) {
        alert('Enter Purchase Type!!!!');
        return;
      }
      if (remarks == '' || remarks == null || remarks == undefined) {
        alert('Enter Remark!!!!');
        return;
      }
    }

    items = JSON.stringify(items);
    let data1 = [];
    let url;
    if (this.props.requestTo == 'Purchaser') {
      url = Server() + 'purchaserequest/insert.php';
      data1 = { 'items': items, 'userId': userId, 'remark': remarks, 'purchaseType': purchaseType };
    }
    else {
      url = Server() + 'stocktransferrequest/insert.php';
      data1 = { 'stock': items, 'date': userId, 'userId': userId, 'remarks': '', 'type': '', 'reference': '' };
    }
    context.setState({
      load: true,
      message: 'Adding Purchase details!!!',
    });
    $.ajax({
      type: 'POST',
      data: data1,
      url: url,
      success: function(data)
      {
        context.setState({ load: false })
        console.log(data);
        if (data == 1) {
          context.props.handleClose();
          context.props.getPurchaseRequest(1, context.props.orderElement, context.props.sortingOrder);
          context.setState({
            items: [],
            remark: false,
            remarks: '',
            purchaseType: '',
          })
        }
      },
      error: function(err)
      {
        context.setState({
          load: false,
        })
      }
    })
  }

  addItem = () => {
    let items = this.state.items;
    let id = 0;
    items.map((c) => {
      id = c.id;
    })
    id = id + 1;
    items.push({id: id, rid: 0});
    this.setState({
      items
    });
  }

  removeItem = (id) => () => {
    let items = [];
    this.state.items.map((x) => {
      if (x.id != id) {
        items.push(x);
      }
    });
    this.setState({ items });
  }

  updateItem = (id, type, value) => {
    let items = this.state.items;
    for (var i = 0; i < items.length; i++) {
      if (items[i].id == id) {
        items[i][type] = value;
        items[i].purchaser = this.state.selectedPurchaser;
        items[i].date = this.state.date;
        items[i].branch = this.props.branch;
        items[i].order_by = this.state.userId;
        items[i].by = this.state.userId;
        items[i].frombranch = this.props.branch;
      }
      if (type == 'stock') {
        items[i].stocks = value;
      }
    }
    this.setState({ items: items })
  }

  addItemArray(id, part_id, partno, brand_id, partname, brand_name, partcode, dropdownvalue, mrp, tax, dnp, ava_stocks) {
    let items = this.state.items;
    for (var i = 0; i < items.length; i++) {
      if (items[i].id == id) {
        items[i].part_id = part_id;
        items[i].partno = partno;
        items[i].brand = brand_id;
        items[i].purchaser = this.state.selectedPurchaser;
        items[i].purchaser_address_id  = this.state.selectedPurchaseraddress;
        items[i].partname = partname;
        items[i].stocksAvailable = ava_stocks;
        items[i].brand_name =  brand_name;
        items[i].partcode = partcode;
        items[i].dropdownvalue = dropdownvalue;
        items[i].mrp = mrp;
        items[i].tax = tax;
        items[i].dnp = dnp;
        items[i].frombranch = this.props.branch;
        items[i].tobranch = this.state.tobranch;
      }
    }
    console.log(items);
    this.setState({ items: items })
  }

  addItemArray1(itemid, id, stock) {
    let items = this.state.items;
    for (var i = 0; i < items.length; i++) {
      if (items[i].id == itemid) {
        items[i].sparesbranchId = id;
        items[i].stocksAvailable =  stock;
      }
    }
    console.log(items);
    this.setState({ items: items })
  }

  getToday() {
    var today = new Date();
    var dd = today.getDate();
    var mm = today.getMonth() + 1; //January is 0!
    var yyyy = today.getFullYear();
    if(dd<10){
      dd='0'+dd
    }
    if(mm<10){
        mm='0'+mm
    }
    today = yyyy+'-'+mm+'-'+dd;
    return today;
  }

  close() {
    this.setState({
      items: []
    })
    this.props.handleClose();
  }

  addItemFromSample(data) {
    this.setState({ items: data })
  }

  changes = (type) => (f, { value }) => {
    this.setState({ [type]: value });
  }

  menu = (f, { value }) => {
    this.setState({ purchaseType: value });
  }

  render() {
    let menuOption = [
      { key: 'Normal', text: 'Normal', value: 'Normal' },
      { key: 'Urgent', text: 'Urgent', value: 'Urgent' }
    ]
    let maxDate = this.getToday();
    const { classes } = this.props;
    let count = 0;
    let total = 0;
    let items = this.state.items.map((x) => {
      console.log(x);
      let stock = x.stock;
      let dnp = x.dnp;
      try {
        stock = Number(stock);
        dnp = Number(dnp);
        total = total + (dnp * stock);
      } catch (e) {

      }
      count++;
      return (
        <Items addItemArray={this.addItemArray.bind(this)}
               addItemArray1={this.addItemArray1.bind(this)}
               count={count} id={x.id} remove={this.removeItem}
               item={x} data={this.state.parts} branch={this.props.branch}
               updateItem={this.updateItem} partcodeOption={this.state.partcodeOption}
               part_id={this.state.part_id} addItem={this.addItem.bind(this)} />
      );
    })
    return (
      <div>
        <Loading load={this.state.load} message={this.state.message} />
        <Dialog fullScreen
          open={this.props.addDialog} onClose={this.close.bind(this)}
          TransitionComponent={Transition}>
          <AppBar className={classes.appBar}>
            <Toolbar>
              <IconButton color="inherit" onClick={this.close.bind(this)} aria-label="Close">
                <CloseIcon />
              </IconButton>
              <Typography variant="h6" color="inherit" className={classes.flex}>
                Add Purchase Request
              </Typography>
            </Toolbar>
          </AppBar>
          <Grid style={{padding: '2%'}}>
            <Grid.Column mobile={16} tablet={16} computer={7}>
              { this.props.requestTo == 'Purchaser' ?
                (
                  <div>
                    Select Purchaser
                    <Dropdown placeholder='Purchaser' style={{ borderColor: '#5A9CBB' }}
                       fluid search selection onChange={this.purchaser}
                       options={this.state.purchaserOption} value={this.state.selectedPurchaseraddress} />
                    <Grid>
                      <Grid.Column mobile={16} tablet={16} computer={8}>
                        State: {this.state.state}
                      </Grid.Column>
                      <Grid.Column mobile={16} tablet={16} computer={8}>
                        GSTIN: {this.state.gstn}
                      </Grid.Column>
                    </Grid>
                  </div>
                ) :
                (
                  <div>
                    Select Branch`s
                    <Dropdown placeholder='Branch' style={{ borderColor: '#5A9CBB' }}
                       fluid search selection onChange={this.tobranchs}
                       options={this.props.branchData} value={this.state.tobranch} />
                  </div>
                )
              }

            </Grid.Column>
            <Grid.Column mobile={16} tablet={16} computer={3}>
              Expected Delivary Date<br/>
              <input type="date" min={maxDate} id="date"
                style={{width: '100%', height: 35 }} onChange={this.handleChange('date')} />
            </Grid.Column>
            <Grid.Column mobile={16} tablet={16} computer={16}>
              { this.state.items.length > 0 ?
                (
                  <table width="100%" id="table">
                    <tr>
                      <th id='tableheader' style={{width: '5%'}}><center>Sino</center></th>
                      <th id='tableheader' style={{width: '15%'}}><center>Partcode</center></th>
                      <th id='tableheader' style={{width: '8%'}}><center>Brand</center></th>
                      <th id='tableheader' style={{width: '8%'}}><center>Enter Qty</center></th>
                      <th id='tableheader' style={{width: '10%'}}><center>Unit Price</center></th>
                      <th id='tableheader' style={{width: '5%'}}><center>DNP</center></th>
                      <th id='tableheader' style={{width: '5%'}}><center>Delete</center></th>
                    </tr>
                    {items}
                  </table>
                ) :
                (
                  <div></div>
                )
              }

            </Grid.Column>
            <Grid.Column mobile={16} tablet={16} computer={16}>
              { this.state.items.length >= 1 ?
                (
                  <div style={{textAlign: 'right', fontSize: 18, color: '#3E668F'}}>{'Rs.'+Number(total).toFixed(2)}</div>
                ):
                (
                  <div></div>
                )
              }
            </Grid.Column>
            </Grid>
            { ((this.state.selectedPurchaser || this.state.tobranch) && this.state.date) ?
              (
                <Grid style={{padding: '2%'}}>
                  <Grid.Column mobile={16} tablet={16} computer={3}>
                    <Button fluid onClick={this.addItem}>Add</Button>
                  </Grid.Column>
                  <Grid.Column mobile={16} tablet={16} computer={3}>
                    <Samplerequest selectedPurchaser={this.state.selectedPurchaser} parts={this.state.parts}
                    addItemFromSample={this.addItemFromSample.bind(this)} allItems={this.state.items}
                    viewEdits={this.props.viewEdits} getPurchaseRequest={this.props.getPurchaseRequest}
                    date={this.state.date} branch={this.props.branch} orderBy={this.state.userId}
                    display='show' />
                  </Grid.Column>
                  <Grid.Column mobile={16} tablet={16} computer={3}>
                    <Button fluid onClick={ () => { this.setState({ remark: true }) }}>Save</Button>
                  </Grid.Column>
                </Grid>
              ) :
              (
                <div></div>
              )
            }
        </Dialog>
        <Dialog open={this.state.remark}
          onClose={this.handleClose} aria-labelledby="responsive-dialog-title" >
          <DialogTitle id="responsive-dialog-title" style={{width: 500}}>
            {"Conform Your Order"}
          </DialogTitle>
          <DialogContent>
            <DialogContentText>
              <div>
                { (this.props.requestTo == 'Purchaser') ?
                  (
                    <Grid>
                      <Grid.Column mobile={16} tablet={16} computer={16}>
                        <Form>
                          <TextArea placeholder='Remark...' onChange={this.changes('remarks')} />
                        </Form>
                      </Grid.Column>
                      <Grid.Column mobile={16} tablet={16} computer={16}>
                        Select Purchase Type<br/>
                        <Dropdown id="Control" onChange={this.menu}
                          search selection options={menuOption}
                          value={this.state.purchaseType} fluid style={{ borderColor: '#5A9CBB', fontSize: 12 }} />
                      </Grid.Column>
                      <Grid.Column mobile={16} tablet={16} computer={8}>
                        <Button fluid onClick={ () => { this.setState({ remark: false }) }}>Cancel</Button>
                      </Grid.Column>
                      <Grid.Column mobile={16} tablet={16} computer={8}>
                        <Button fluid onClick={this.submit.bind(this)}>Conform</Button>
                      </Grid.Column>
                    </Grid>
                  ) :
                  (
                    <div>
                      Request to Branch<br/><br/>
                      <center><Button fluid onClick={this.submit.bind(this)}>Conform</Button></center>
                    </div>
                  )
                }
              </div>
            </DialogContentText>
          </DialogContent>
        </Dialog>
      </div>
    );
  }
}

FullScreenDialog.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(FullScreenDialog);
